import React from 'react'
import styled from '@emotion/styled'
import _ from 'lodash'
import {
	L2TabularListRoot,
	L2TabularListHeader,
	L2TabularListContent,
	L2TabularListActions,
} from '../l2/L2TabularList'
import {
	L2TabularListItemSummary,
} from '../l2/L2TabularListItem'
import { L1PlainIconButton, L1ReasonableButton } from '../l1/L1Button'
import { faTrashCan, faUserPen } from '@fortawesome/pro-regular-svg-icons'
import { FusionColor } from '../../../theme/FusionStyle'

export interface L3AmputationListModel {
	cid: string
	dirItemId: number
	title: string
}

interface L3AmputationListProps {
	models?: L3AmputationListModel[],
	deleteModel: (model: L3AmputationListModel) => void,
	onAddClick?: (e: React.MouseEvent<HTMLButtonElement>) => void,
}

const DeleteButtonCell = styled.div({
	justifySelf: 'right',
})

export const L3AmputationList = ({models = [], deleteModel, onAddClick}: L3AmputationListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		return (
			<L2TabularListItemSummary key={modelIdx}>
				<div>{model.title}</div>
				<DeleteButtonCell>
					<L1PlainIconButton
						icon={faTrashCan}
						color={FusionColor.StopRed}
						onClick={() => deleteModel(model)}
					/>
				</DeleteButtonCell>
			</L2TabularListItemSummary>
		)
	})
	return (
		<L2TabularListRoot columnCount={2}>
			<L2TabularListHeader>
				<div>Description</div>
				<div></div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
			{onAddClick ? (<L2TabularListActions>
				<L1ReasonableButton icon={faUserPen} label="Add" onClick={onAddClick} />
			</L2TabularListActions>) : null}
		</L2TabularListRoot>
	)
}
